export enum TAX_TYPE {
  exempt = 1,
  licensed_il = 2,
}

export enum TRANSACTION_TYPES {
  customer_driver_transaction = 1,
  customer_company_transaction = 2,
  company_driver_transaction = 3,
  company_store_transaction = 4,
  driver_company_transaction = 5,
  company_store_debt = 6,
  company_driver_debt = 7,
  company_customer_balance_credit = 8,
}

export const TRANSACTION_TYPES_NAME_MAP: {
  [key: number]: string;
} = {
  0: 'All',
  1: 'Customer->Captain',
  2: 'Customer->Company',
  3: 'Company->Captain',
  4: 'Company->Store',
  5: 'Captain->Company',
  6: 'Company Store Debt',
  7: 'Company Captain Debt',
  8: 'Company Customer Credit',
};

export enum TRANSACTION_STATUS {
  zero = 0,
  pending = 1,
  completed = 2,
  cancelled = 3,
}

export const TRANSACTION_STATUS_NAME_MAP: {
  [key: number]: string;
} = {
  0: 'All',
  1: 'Pending',
  2: 'Completed',
  3: 'Cancelled',
};

export enum TRANSACTION_METHODS {
  zero = 0,
  cash = 1,
  card = 2,
  mobile_payment = 3,
  bank_transfer = 4,
  debt = 5,
  balance_credit = 6,
}

export const TRANSACTION_METHODS_NAME_MAP: {
  [key: number]: string;
} = {
  0: 'All',
  1: 'Cash',
  2: 'Card',
  3: 'Mobile',
  4: 'Bank',
  5: 'Debt',
  6: 'Balance Credit',
};

export interface Transaction {
  transaction_id: number;
  transaction_type: number;
  transaction_type_name: string;
  transaction_amount: string;
  transaction_creation_date: string;
  transaction_completion_date: string;
  transaction_method: number;
  transaction_method_name: string;
  transaction_status: number;
  transaction_status_name: string;
  transaction_additional_context?: any;
  order_id?: number;
}

export interface StoreTransaction extends Transaction {
  store_id: number;
  balance: string;
}

export interface DriverTransaction extends Transaction {
  customer_id: number;
  driver_id: number;
  cash_balance_debt_to_silal: string;
  revenue_balance_debt_to_driver: string;
}

export interface StorePayout {
  store_id: number;
  amount: number;
  additional_context?: string;
}

export interface DriverPayout {
  driver_id: number;
  amount: number;
  additional_context?: string;
}

export interface StorePaymentReportTransaction {
  store_id: number;
  tax_id: string;
  bank_number: number;
  bank_branch_number: number;
  bank_account_number: number;
  store_name: string;
  das_percentage?: any;
  balance: string;
}

export interface DriverPaymentReportTransaction {
  driver_id: number;
  driver_name: string;
  tax_id: string;
  bank_number: number;
  bank_branch_number: number;
  bank_account_number: number;
  das_percentage?: any;
  cash_balance_debt_to_silal: string;
  revenue_balance_debt_to_driver: string;
}

export interface OrderLedgerTransaction extends Transaction {
  amount_paid_by_customer_in_cash: number;
  amount_paid_by_customer_in_credit_card: number;
  amount_paid_by_customer_in_credit_balance: number;
  amount_paid_by_customer: number;
  amount_refunded_in_credit_balance: number;
  amount_refunded_in_credit_card: number;
  amount_refunded: number;
  debt_to_store_pre_deductions: number;
  pending_debt_to_store: number;
  amount_deducted_from_store_debt: number;
}
